export const eventsReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_EVENT_LIST_REQUEST":
      return {
        ...state,
        events: null,
        loading: true,
      };

    case "GET_EVENT_LIST_SUCCESS":
      return {
        ...state,
        events: action.payload,
        loading: false,
      };

    case "GET_EVENT_LIST_FAILED":
      return {
        ...state,
        events: action.payload,
        loading: false,
      };

    case "VIEW_EVENT_REQUEST":
      return {
        ...state,
        event: null,
        loading: true,
      };

    case "VIEW_EVENT_SUCCESS":
      return {
        ...state,
        event: action.payload,
        loading: false,
      };

    case "VIEW_EVENT_FAILED":
      return {
        ...state,
        event: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
